import { createAction, props } from '@ngrx/store';
import {PaperChatFilterType} from '../../../chat/dto/paper-chat';

export const downloadCSV = createAction('[File Download] Download CSV',
  props<{ projectId: number, filter: PaperChatFilterType }>()
);
export const downloadCSVSuccess = createAction('[File Download] Download CSV Success');
export const downloadCSVFailure = createAction(
  '[File Download] Download CSV Failure',
  props<{ error: any }>()
);

export const downloadBibtex = createAction('[File Download] Download Bibtex',
  props<{ projectId: number, filter: PaperChatFilterType }>()
);
export const downloadBibtexSuccess = createAction('[File Download] Download Bibtex Success');
export const downloadBibtexFailure = createAction(
  '[File Download] Download Bibtex Failure',
  props<{ error: any }>()
);
